// removed by extract-text-webpack-plugin
module.exports = {"container":"beta-setting__container___3pPnU"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/settings/beta-setting.scss
// module id = 1354
// module chunks = 0